import { SvgIcon } from "@mui/material";

function ArrowIcon(props) {
    return (
        <SvgIcon
            {...props}
            viewBox="0 0 24 24"
            sx={{
                fill: "#ffffff",
                transition: "all 0.3s ease",
                ...props.sx
            }}
        >
            <path d="M8 5l8 7-8 7z" />
        </SvgIcon>
    );
}

export default ArrowIcon;
